import AxiosWrapper from "../../basecomp/base/AxiosWrapper"
import { fetchData } from "../apis/apis";

let prevurl;
async function ViewHistoryApi(url) {
        // console.log(ticketId);
        // console.log(ticketHeading);
        // console.log(ticketTool);
        // console.log(ticketDate);
       
        // console.log("No data");
        // let response = await AxiosWrapper.axiosGetCallWithToken(url, new FormData())
        try{

        console.log("calling api");
        let response= await fetchData(url,new FormData())
        console.log("this is response");
        console.log(response);
        return response.data
        }
        catch(error){
                throw error;
        }

        // console.log("incoming data in api");
        // console.log(response.data.ticket_data);
        // console.log(response.data.upload_path);
        // console.log("ended data in api");

}

export default ViewHistoryApi